import { Skeleton } from '@iheartjane/reefer';

import styles from './storeSwitcherSkeleton.module.css';

export const StoreSwitcherSkeleton = () => (
  <Skeleton animate>
    <div className={styles['storeCard']}>
      <Skeleton.Bone height={200} mb={32} className={styles['storeDetail']} />
      <Skeleton.Bone
        height={24}
        width={240}
        mb={8}
        className={styles['storeDetail']}
      />
      <Skeleton.Bone
        height={24}
        width={240}
        mb={8}
        className={styles['storeDetail']}
      />
      <Skeleton.Bone
        height={24}
        width={80}
        mb={16}
        className={styles['storeDetail']}
      />
      <Skeleton.Bone
        height={48}
        width={311}
        mb={24}
        className={styles['storeDetail']}
      />
    </div>
    <Skeleton.Bone
      height={24}
      width={240}
      mb={8}
      mt={32}
      className={styles['storeDetail']}
    />
    <Skeleton.Bone
      height={24}
      width={240}
      mb={-8}
      className={styles['storeDetail']}
    />
  </Skeleton>
);
